export default import.meta.ROLLDOWN_FILE_URL_R2nbcAsJ5OYlRa80zecvlQ